// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function PromotionStatusBadge(props) {
  let status = props.status;
  if (status === "STOPPED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Stopped"),
      variation: "danger"
    });
  } else if (status === "ARCHIVED") {
    return null;
  } else if (status === "DRAFT") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Draft"),
      variation: "neutral"
    });
  } else if (status === "NOT_PROGRAMMED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Unscheduled"),
      variation: "danger"
    });
  } else if (status === "ONGOING") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Ongoing"),
      variation: "success"
    });
  } else if (status === "EXPIRED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Expired"),
      variation: "warning"
    });
  } else {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Scheduled"),
      variation: "information"
    });
  }
}

let make = React.memo(PromotionStatusBadge);

export {
  make,
}
/* make Not a pure module */
